// Atalhos de prazo das tarefas. Trabalham com "YYYY-MM-DD" no fuso do
// usuário; a leitura do prazo salvo fica em helpers/taskDue.
import { taskDueInput } from "../../helpers/taskDue";

export const PRIORITY_OPTIONS = [
  { value: "high", label: "Alta", color: "#e53935" },
  { value: "medium", label: "Média", color: "#fb8c00" },
  { value: "low", label: "Baixa", color: "#1e88e5" },
];

const pad = (n) => String(n).padStart(2, "0");

// Date local → "YYYY-MM-DD"
export const toLocalInput = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;


const addDays = (base, days) => {
  const d = new Date(base);
  d.setDate(d.getDate() + days);
  return d;
};

const nextMonday = (base) => {
  const d = new Date(base);
  const diff = ((8 - d.getDay()) % 7) || 7; // segunda que vem (nunca hoje)
  d.setDate(d.getDate() + diff);
  return d;
};

// atalhos de prazo usados ao criar/editar
export const dueShortcuts = (now = new Date()) => [
  { key: "today", label: "Hoje", value: toLocalInput(now) },
  { key: "tomorrow", label: "Amanhã", value: toLocalInput(addDays(now, 1)) },
  { key: "monday", label: "Próx. segunda", value: toLocalInput(nextMonday(now)) },
  { key: "none", label: "Sem prazo", value: "" },
];

// opções de "Adiar" a partir do prazo atual (ou de hoje, se já venceu/não tem)
export const postponeOptions = (task, now = new Date()) => {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let base = today;
  const dueInput = taskDueInput(task);
  if (dueInput) {
    const [y, m, d] = dueInput.split("-").map(Number);
    const due = new Date(y, m - 1, d);
    if (due > today) base = due;
  }
  const options = [
    { key: "tomorrow", label: "Amanhã", value: toLocalInput(addDays(today, 1)) },
    { key: "plus3", label: "+3 dias", value: toLocalInput(addDays(base, 3)) },
    { key: "monday", label: "Próxima segunda", value: toLocalInput(nextMonday(today)) },
    { key: "week", label: "+1 semana", value: toLocalInput(addDays(base, 7)) },
  ];
  // ex.: no domingo, "Amanhã" e "Próxima segunda" são o mesmo dia
  return options.filter((o, i) => options.findIndex((x) => x.value === o.value) === i);
};
